import { MessageReader } from "../../message_handlers/message_reader.js";

export class SessionStartResponse
{
  public session_id: string | null = null;

  public deserialize( reader: MessageReader ): void
  {
    reader.readBody();
    this.session_id = reader.getBodyElement<string>( 'sessionid' ) ?? null;
  }
}
